import request from '@/utils/request';
import { AjaxMethod } from '@/utils/dataMap';

//获取成员列表
export const getUsersListApi = data => {
	return request({
		url: '/api/common/plug-user-list',
		method: AjaxMethod.post,
		data,
	});
};
